// import './sentry';
import { register } from 'swiper/element/bundle';
import './nav.ts';
import { Accordion } from './utils/accordion';
import ArtworkFilter from './components/ArtworkFilter.svelte';
import ArtworkList from './components/ArtworkList.svelte';
import { mount } from 'svelte';
register();

// Uncomment to enhance details/summary elements
const accordions = Array.from(document.querySelectorAll('details'));
accordions.forEach(accordion => {
	new Accordion(accordion);
});

const updateHeight = (elem: HTMLElement, target: HTMLElement) =>
	elem.style.setProperty('--observed-height', `${target.clientHeight}px`);

Array.from(document.querySelectorAll('[data-height]')).forEach(elem => {
	const target = document.querySelector(elem.dataset.height);

	const callback = () => updateHeight(elem, target);

	if ('ResizeObserver' in window) {
		const observer = new ResizeObserver(callback);
		observer.observe(elem);
	}
});

const artworkFilter = document.querySelector('[data-artwork-filter]');
if (artworkFilter) {
	const data = JSON.parse(artworkFilter.dataset.artworkFilter);
	mount(ArtworkFilter, { target: artworkFilter, props: data });
}
const artworkList = document.querySelector('[data-artwork-list]');
if (artworkList) {
	const data = JSON.parse(artworkList.dataset.artworkList || 'null');
	mount(ArtworkList, { target: artworkList, props: data });
}

const initArtistList = async target => {
	const { default: ArtistList } = await import(
		'./components/ArtistList.svelte'
	);
	const data = JSON.parse(target.dataset.artistList || 'null');
	mount(ArtistList, { target, props: data });
};

const artistList = document.querySelector('[data-artist-list]');
if (artistList) {
	initArtistList(artistList);
}

const shareButton = document.querySelector(
	'button[data-share]',
) as HTMLButtonElement;

if (shareButton) {
	const shareData = JSON.parse(shareButton.dataset.share || '');
	if ('share' in navigator && navigator.canShare(shareData)) {
		shareButton.addEventListener('click', () => {
			try {
				navigator.share(shareData);
			} catch (e) {
				console.error(e);
			}
		});
	} else {
		shareButton.remove();
	}
}

const xhrForms = Array.from(
	document.querySelectorAll('[data-xhr]'),
) as HTMLFormElement[];

xhrForms.forEach(form => {
	form.addEventListener('submit', async e => {
		e.preventDefault();
		if (form.hasAttribute('data-is-pending')) {
			return;
		}
		const output =
			form.querySelector("[role='status']") ??
			form.closest('.form')?.querySelector("[role='status']");
		if (output) {
			output.innerHTML = '';
		}

		const params = new FormData(form);

		let response;
		try {
			form.setAttribute('data-is-pending', 'true');
			response = await fetch(form.action, {
				method: form.method,
				headers: {
					Accept: 'application/json',
				},
				body: params,
			});
		} catch (error) {
			console.error('There was an error', error);
		}

		if (response?.ok) {
			const json = await response.json();
			if (output) {
				output.innerHTML = json.message;
			}
			if (form.dataset.xhr === 'hideAfterSuccess') {
				form.hidden = true;
			}
			if (typeof json.pressed !== 'undefined') {
				const pressableButton = e.target.querySelector('[aria-pressed]');
				pressableButton?.setAttribute('aria-pressed', json.pressed);
			}
			if (typeof json.disabled !== 'undefined') {
				const pressableButton = e.target.querySelector('[aria-pressed]');
				pressableButton?.setAttribute('disabled', 'disabled');
			}
		} else {
			const json = await response?.json();
			if (output) {
				output.innerHTML = json.message;
			}
			if (typeof json.pressed !== 'undefined') {
				const pressableButton = e.target.querySelector('[aria-pressed]');
				pressableButton?.setAttribute('aria-pressed', json.pressed);
			}
			if (typeof json.disabled !== 'undefined') {
				const pressableButton = e.target.querySelector('[aria-pressed]');
				pressableButton?.setAttribute('disabled', 'disabled');
			}
		}
		if (output && output.hasAttribute('popover')) {
			output.showPopover();
		}
		form.removeAttribute('data-is-pending');
	});
});

const mediaPlayers = document.querySelectorAll('media-controller');
if (mediaPlayers.length) {
	import('media-chrome');
}
